module.exports = __webpack_public_path__ + "th.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/th.svg
// module id = 1093
// module chunks = 0